import React from "react";

import No_ShiftListingIcon from "../Icons/NoData/No_ShiftListingIcon";

/**
 * A function that renders a table with no content.
 *
 * @return {JSX.Element} The rendered JSX for the table with no content.
 */
const TableNoContent = () => {
  return (
    <div className="flex flex-col items-center py-[50px]">
      <No_ShiftListingIcon />
      <span className="text-[18px] font-semibold leading-[normal] text-primary">
        No Data found
      </span>
    </div>
  );
};

export default TableNoContent;
